/* eslint-disable unicorn/filename-case -- TODO rename later */
export const userQueryKeys = {
  all: ["user"],
  byId: (id: string) => [...userQueryKeys.all, "id", id],
};
